import { FC } from "react";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { SalesConfirmationFilter } from "api/salesConfirmation";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: SalesConfirmationFilter) => void;
	filterOptions: SalesConfirmationFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	return (
		<div className="filter-container">
			<div className="filter-items sales-confirmation-filter-items">
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						format={DATE_FORMAT}
						className="height-inherit"
						style={{ width: "100%" }}
						value={filterOptions.fromDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								fromDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						style={{ width: "100%" }}
						value={filterOptions.toDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								toDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>
				<div className="sales-confirmation-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							name: filterOptions.buyerName || " "
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
			</div>

			<div className="filter-end-btn sales-confirmation-filter-end-btn">
			{/*	<CustomButton*/}
			{/*		label={"PDF"}*/}
			{/*		onClick={() => exportAsPDF()}*/}
			{/*		iconName={ICON_NAMES.Download}*/}
			{/*	/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
